import request from '../../utils/request';

//
export async function getAppList(params) {
  return request({ url: 'app/getAppList', params });
}

//
export async function saveOrUpdateVer(params) {
  return request({ url: 'app/saveOrUpdateVer', params, normalP: true });
}

//
export async function getAppVerById(params) {
  return request({ url: 'app/getAppVerById', params, normalP: true });
}

// 灰度版本的商行列表
export async function getTradingCompanyList(params) {
  return request({ url: 'versionRefer/list', params, headers: 'json' });
}

// 灰度版本的新增商行
export async function getVersionReferAdd(params) {
  return request({ url: 'versionRefer/add', params });
}

// 在灰度版本升级的商行列表移除目标商行
export async function deleteVersionRefer(params) {
  return request({ url: 'versionRefer/delete', params });
}

// 发送版本更新推送消息
export async function updatePush(params) {
  return request({ url: 'app/updates/push', method: 'get', headers: 'json', params });
}
